<template>
  <div class="board row"
    v-on:dragenter="$event.preventDefault()"
    v-on:dragover="$event.preventDefault()"
    >
    <div class="col-12">
      <div class="head-column">
        <div v-for="n in 15" v-bind:key="n">{{n}}</div>
      </div>
    </div>
    <div v-for="(squares, index) in board.squares" v-bind:key="index" class="line col-12">
      <div class="line-header text-end">{{alpha[index]}}</div>
      <Square v-for="square in squares" v-bind:square="square"
      v-bind:key="`${square.row}-${square.column}`"
      v-bind:roundNumber="roundNumber"
      v-bind:horizontal="horizontal"
      v-bind:selected="squareClicked
        && square.row === squareClicked.row && square.column === squareClicked.column"
      v-bind:premium="premium"
      v-on:tile-dropped="drop"
      v-on:open-letter-selection="openLetterSelection"
      v-on:click-square="clickSquare"
      v-on:move-to-draw="moveToDraw"
      ></Square>
      <div class="line-header d-none d-lg-block">{{alpha[index]}}</div>
    </div>
    <div class="col-12 d-none d-lg-block">
      <div class="head-column">
        <div v-for="n in 15" v-bind:key="n">{{n}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Square from './Square.vue';

export default {
  name: 'Board',
  emits: ['tile-moved', 'open-letter-selection', 'click-square'],
  props: {
    board: {
      type: Object,
      required: true,
    },
    roundNumber: {
      type: Number,
      required: true,
    },
    squareClicked: {
      type: Object,
      required: false,
    },
    horizontal: {
      type: Boolean,
      required: false,
    },
    premium: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      alpha: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O'],
    };
  },
  components: { Square },
  methods: {
    drop(event) {
      this.$emit('tile-moved', event);
    },
    openLetterSelection(tile) {
      this.$emit('open-letter-selection', tile);
    },
    clickSquare(square) {
      this.$emit('click-square', square);
    },
    moveToDraw(tile) {
      this.$emit('tile-moved', tile);
    },
  },
};
</script>

<style>
.board *{
  -moz-user-select: -moz-none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.line {
  height: 20px;
}

.line .square{
  float: left;
  height: 20px;
  width: 19px;
}

.head-column{
  height: 14px;
  font-size: 10px;
  padding-left: 10px;
  text-align: center;
}
.head-column div{
  float: left;
  height: 14px;
  width: 19px;
  padding-left: 2px;
}
.line-header{
  float: left;
  padding: 2px;
  height: 20px;
  width: 10px;
  font-size: 10px;
}

@media (min-width: 992px) {
  .line {
    height: 38px;
  }
  .line .square{
    height: 38px;
    width: 38px;
  }
  .head-column{
    height: 14px;
    padding-left: 14px;
  }
  .head-column div{
    height: 14px;
    width: 38px;
    padding-left: 8px;
  }
  .line-header{
    padding-top: 12px;
    height: 38px;
    width: 18px;
  }
}
</style>
